import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, grayColor, blueColor, oceanBlueColor, DodgerBlueColor} from '../../cmsMainStyle'

const loadScreenLoadStyle = theme => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		
	},

	circular: {
		color: oceanBlueColor[10],
	}
})


export default loadScreenLoadStyle